export default __webpack_public_path__ + "static/media/523.4e2aed68.png";